import { actionStatus, ActionResponse } from './action-creator';


export type StoreAsyncItem<T> = {
	isFetching: boolean;
	isLoaded: boolean;
	didInvalidate: boolean;
	item: T;
}

function createReducerCreatorPack() {
	function createReducer<S>(initialState: S, actionMap: Record<string, (action: ActionResponse<any>, state: S) => Partial<S>>) {
		return (state = initialState, action) => {
			const fn = actionMap[action.type] || (() => state);
	
			return {
				...state,
				...fn(action, state)
			};
		}
	}
	
	function createAsyncInitialState<T>(item = null): StoreAsyncItem<T> {
		return {
			isFetching: false,
			isLoaded: false,
			didInvalidate: false,
			item
		};
	}
	
	function checkAsyncAction<T>(action: ActionResponse<T>, state, processItem?: (item: T) => unknown) {
		const { status, value } = action.payload;
	
		if (status === actionStatus.REQUESTED) {
			return {
				...state,
				isFetching: true,
				didInvalidate: false
			}
		} else if (status === actionStatus.RECEIVED) {
			return {
				isFetching: false,
				isLoaded: true,
				didInvalidate: false,
				item: typeof processItem === 'function'
					? processItem(value)
					: value
			}
		}
	
		return state;
	}
	
	function invalidateStateFromAction<T>(action: ActionResponse<T>, state) {
		const { status } = action.payload;
	
		if (status === actionStatus.REQUESTED) {
			return {
				...state,
				isFetching: true
			}
		} else if (status === actionStatus.RECEIVED || status === actionStatus.STATIC_ACTION) {
			return {
				...state,
				isFetching: false,
				didInvalidate: true
			}
		}
	
		return state;
	}

	return {
		createReducer,
		createAsyncInitialState,
		checkAsyncAction,
		invalidateStateFromAction,
	}
}

export default createReducerCreatorPack;
